import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectoParticipanteTutorDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';



import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProyectoParticipanteTutorService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getProyectoParticipanteTutorService(): Observable<BodyListResponse<ProyectoParticipanteTutorDTO>> {
    return this.http.get<BodyListResponse<ProyectoParticipanteTutorDTO>>(API_URL + '/api/v1/proyectoParticipanteTutor/todos');
  }

  guardarProyectoParticipanteTutorService(proyectoParticipanteTutorDTO: ProyectoParticipanteTutorDTO): Observable<BodyResponse<ProyectoParticipanteTutorDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/proyectoParticipanteTutor', proyectoParticipanteTutorDTO);
  }

  getProyectoParticipanteTutorPorCodigoService(codigo: string): Observable<BodyResponse<ProyectoParticipanteTutorDTO>> {
    return this.http.get<BodyResponse<ProyectoParticipanteTutorDTO>>(API_URL + '/api/v1/proyectoParticipanteTutor/' + codigo);
  }
  /*** */
  getObtenerTutoresPorTutorEstadoProyecto(numeroIdentificacion: string, estadoProyecto: string): Observable<BodyListResponse<ProyectoParticipanteTutorDTO>> {
    return this.http.get<BodyListResponse<ProyectoParticipanteTutorDTO>>(API_URL + '/api/v1/proyectoParticipanteTutor/numeroIdentificacion/estado/' + numeroIdentificacion + '/' + estadoProyecto);
  }

  obtenerTutorPorPlanTrabajoPorEstudiante(idTutor: string, idEstudiante: string) {
    return this.http.get<BodyListResponse<ProyectoParticipanteTutorDTO>>(API_URL + '/api/v1/proyectoParticipanteTutor/plan/estudiante/' + idTutor + '/' + idEstudiante);
  }

  obtenerTutorPorCodigoPlanTrabajoPorEstudiantesConstroller(codigoPlan: string) {
    return this.http.get<BodyListResponse<ProyectoParticipanteTutorDTO>>(API_URL + '/api/v1/proyectoParticipanteTutor/plan/' + codigoPlan);
  }

}
